const func = $target => {
	var $modal = $('.modal#deleteProductModal'),
        $input = $modal.find('input#deleteLineItemId');

    $modal.on('show.bs.modal', function(e) {
		$input.attr('name', 'lineItems['+$(e.relatedTarget).parents('[data-mod="lineItem"]').data('id')+'][remove]');
	})
	.on('hidden.bs.modal', function(e) {
		$input.attr('name', '');
	});
};


export default func;